export class SapDiscoveryResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "objects",
            "baseName": "objects",
            "type": "Array<SapObject>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SapDiscoveryResponse.attributeTypeMap;
    }
    constructor() {
    }
}
